import { useTitle } from "react-use";
import { Box } from "../components/Box";
import { Container } from "../components/Container";
import { LayoutScroll } from "../layout/LayoutScroll";
import { Text } from "../components/Text";
import { useSetLogoStyle } from "../hooks/useSetLogoStyle";
import { FlexContainer, FlexItem } from "../components/Flex";
import { motion } from "framer-motion";
import { ImageFill } from "../components/ImageFill";
import styled from "styled-components";
import Button from "../components/Button";

const ImgContainer = styled(motion.div)`
  padding-top: 80%;
  position: relative;
  box-shadow: 50px 20px 100px 0 rgba(0, 0, 0, 0.41);
  background-color: white;
  cursor: pointer;
`;

const imageVariants = {
  initial: { opacity: 0, x: -20 },
  animate: { opacity: 1, x: 0 },
};

const LabelWrapper = styled.div`
  position: absolute;
  top: 24px;
  left: 24px;
  transform: rotate(-90deg) translateX(-100%);
  transform-origin: 0 0;
`;

const Page = styled(Box)`
  flex: 1;
`;

export const About: React.FC = () => {
  useSetLogoStyle("dark");

  useTitle("About Boots Exhibition");

  return (
    <LayoutScroll>
      <Page pt={6} backgroundColor="melonLight">
        <Box mb={[4, null, 5, null, 6]}>
          <FlexContainer
            flexWrap="wrap"
            alignItems="center"
            justifyContent="space-between"
          >
            <FlexItem
              flex={["0 0 100%", null, null, "0 0 45%", "0 0 53%"]}
              mb={[32, null, null, 0]}
            >
              <ImgContainer
                variants={imageVariants}
                initial="initial"
                animate="animate"
                transition={{ duration: 0.6, delay: 1, ease: "easeInOut" }}
                whileHover={{ scale: 1.01 }}
              >
                <ImageFill
                  src="/assets/images/store_of_future.jpg"
                  alt="Unknown Boots store, 1980s"
                  fit="cover"
                />
                <LabelWrapper>
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 0.6,
                      delay: 1.5,
                      ease: "easeOut",
                    }}
                  >
                    <Text variant="small" color="white">
                      Unknown Boots store, 1980s
                    </Text>
                  </motion.div>
                </LabelWrapper>
              </ImgContainer>
            </FlexItem>
            <FlexItem flex={["0 0 100%", null, null, "0 0 50%", "0 0 42%"]}>
              <Container pl={[3, 4, null, 0]}>
                <Box mb={3} maxWidth={800}>
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.6, delay: 1.6 }}
                  >
                    <Box maxWidth="520px">
                      <Text variant="h1" mb={3}>
                        About this exhibition
                      </Text>
                      <Text variant="body">
                        This exhibition was jointly curated by the Boots Archive
                        team and Dr Katey Logan and was supported by The
                        Wellcome Trust [106770/Z/15/B]. More information and
                        images are available on Boots online archive catalogue.
                      </Text>

                      <Box mt={4}>
                        <a
                          href="http://archives.walgreensbootsalliance.com/"
                          target="_blank"
                        >
                          <Button icon="arrowForward" color="hotPink">
                            Visit archive
                          </Button>
                        </a>
                      </Box>
                    </Box>
                  </motion.div>
                </Box>
              </Container>
            </FlexItem>
          </FlexContainer>
        </Box>
      </Page>
    </LayoutScroll>
  );
};
